@if (getErrorEntries().length > 0) {
  <div class="form-inline-error" role="alert">
    @for (error of getErrorEntries(); track error[0]) {
      <div class="error-message">
        {{ formatErrorMessage(error[0], error[1]) }}
      </div>
    }
  </div>
}
